module.exports = __webpack_public_path__ + "static/media/Refund_and_Return_Policy_FSA.08fe6570.pdf";